S.customSelectMenu = {
    config: {
        element: null,
    },
    element: {
        $customSelectMenu: null,
    },

    /** @var {jQuery} $mobileSelectMenu*/
    $customSelectMenu: null,

    /** @var {jQuery} $mobileSelectMenu*/
    $neededModule: null,

    /** @var {jQuery} $libraryInstance*/
    $libraryInstance: null,

    init()
    {
    },

    start()
    {

        if (this.$libraryInstance === null)
        {
            this.$neededModule = this.$module.closest('.mod-audiobook-series-wall');
        }
        
        var i, j, l, ll, selElmnt, a, b;

        let copyOption, selectMenuContainer;

        const that = this;

        selectMenuContainer = document.getElementsByClassName('m-select-menu');
        l = selectMenuContainer.length;

        for (i = 0; i < l; i++)
        {
            selElmnt = selectMenuContainer[i].getElementsByTagName('select')[0];
            ll = selElmnt.length;
            /* For each element, create a new DIV that will act as the selected item: */
            a = document.createElement('DIV');
            a.setAttribute('class', 'm-select-selected');
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            selectMenuContainer[i].appendChild(a);
            /* For each element, create a new DIV that will contain the option list: */
            b = document.createElement('DIV');
            b.setAttribute('class', 'm-select-items select-hide');
            for (j = 1; j < ll; j++)
            {
                /* For each option in the original select element,
                create a new DIV that will act as an option item: */
                copyOption = document.createElement('DIV');
                copyOption.innerHTML = selElmnt.options[j].innerHTML;

                // just for the first entry, set it as default
                if (j === 1)
                {
                    copyOption.setAttribute('class', 'same-as-selected');
                }

                // set data type
                copyOption.setAttribute('data-type', j);

                if (that.$libraryInstance !== null) {
                    if (selElmnt.options[j].classList.contains('m-empty')) {
                        copyOption.setAttribute('class', 'm-empty')
                    }
                }

                copyOption.addEventListener('click', function (e)
                {
                    /* When an item is clicked, update the original select box,
                    and the selected item: */
                    var y, i, k, s, h, sl, yl;
                    s = this.parentNode.parentNode.getElementsByTagName('select')[0];

                    sl = s.length;
                    h = this.parentNode.previousSibling;
                    for (i = 0; i < sl; i++)
                    {
                        if (s.options[i].innerHTML == this.innerHTML)
                        {
                            if (s.options[i].classList.contains('m-empty'))
                            {
                                return;
                            }

                            s.selectedIndex = i;
                            h.innerHTML = this.innerHTML;
                            y = this.parentNode.getElementsByClassName('same-as-selected');
                            yl = y.length;
                            for (k = 0; k < yl; k++)
                            {
                                y[k].removeAttribute('class');
                            }
                            this.setAttribute('class', 'same-as-selected');
                            break;
                        }
                    }

                    if (that.$libraryInstance === null)
                    {
                        // set parent trigger attribute
                        that.$neededModule.attr('data-type', e.currentTarget.getAttribute('data-type'));
                    }
                    else
                    {
                        if (s.options[i].classList.contains('m-empty'))
                        {
                            e.preventDefault();
                            return;
                        }

                        that.$libraryInstance.handleMobileSelect(e.currentTarget);
                    }


                    h.click();
                });

                b.appendChild(copyOption);
            }
            selectMenuContainer[i].appendChild(b);
            a.addEventListener('click', function (e)
            {
                /* When the select box is clicked, close any other select boxes,
                and open/close the current select box: */
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle('select-hide');
                this.classList.toggle('select-arrow-active');
            });
        }

        function closeAllSelect(elmnt)
        {
            /* A function that will close all select boxes in the document,
            except the current select box: */
            var x, y, i, xl, yl, arrNo = [];
            x = document.getElementsByClassName('m-select-items');
            y = document.getElementsByClassName('m-select-selected');
            xl = x.length;
            yl = y.length;
            for (i = 0; i < yl; i++)
            {
                if (elmnt == y[i])
                {
                    arrNo.push(i);
                }
                else
                {
                    y[i].classList.remove('select-arrow-active');
                }
            }
            for (i = 0; i < xl; i++)
            {
                if (arrNo.indexOf(i))
                {
                    x[i].classList.add('select-hide');
                }
            }
        }

        /* If the user clicks anywhere outside the select box,
        then close all select boxes: */
        document.addEventListener('click', closeAllSelect);

        if (this.$libraryInstance === null)
        {
            // init selection logic
            this.initEvents(this.$neededModule);
        }
        else {
            this.$libraryInstance.$fakeBtnChar = this.$module.find('.m-select-items > div')
        }
    },

    /**
     *
     * @param $neededModule
     */
    initEvents($neededModule)
    {
        this.$module.find('.m-select-item-desktop').on('click', (e) =>
        {

            // set parent trigger attribute
            $neededModule.attr('data-type', e.currentTarget.getAttribute('data-type'));
        });
    },
};
